__turbopack_context__.v({
  "active": "toggleButtonGroup-module-scss-module__pzEH1W__active",
  "button": "toggleButtonGroup-module-scss-module__pzEH1W__button",
  "group": "toggleButtonGroup-module-scss-module__pzEH1W__group",
});
